import { render, staticRenderFns } from "./BigQueryTable.vue?vue&type=template&id=18d14ff2&"
import script from "./BigQueryTable.vue?vue&type=script&lang=js&"
export * from "./BigQueryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports